export const ArchivingStatus = {
    WAITING: "WAITING",
    ARCHIVED: "ARCHIVED",
    ARCHIVE_EXPIRED: "ARCHIVE_EXPIRED"
}

export const statusScheduleAvailable = (status) => {
    return !status || ArchivingStatus.ARCHIVE_EXPIRED === status;
}